import { render } from "./PageTransitionsNr1.vue?vue&type=template&id=60f71525"
import script from "./PageTransitionsNr1.vue?vue&type=script&lang=js"
export * from "./PageTransitionsNr1.vue?vue&type=script&lang=js"

import "./PageTransitionsNr1.vue?vue&type=style&index=0&id=60f71525&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__